<template>
  <div class="container">
    <h1 class="container-title">List of Members</h1>
    <text-field
      append-icon="search"
      style="width: 65%"
      label="Search Members by Name or Member ID number"
    />
    <div v-if="!$apollo.loading" class="attendee_table">
      <div
        v-if="members.length === 0"
        class="no-attendees-message-container border__left border__right"
      >
        <span class="no-attendees-message">No matching records found.</span>
      </div>
      <table-list
        :hide-checkbox="true"
        :selected.sync="selected"
        :organization-slug="organizationSlug"
        :attendees="members"
        body-style="grid-auto-columns: 50px minmax(150px, 250px) !important;"
        :visible-fields="visibleFields"
        :attendee-fields="attendeeFields"
        :pagination="pagination"
        @click="$emit('editPlan', $event)"
        @sort="handleSort($event)"
      />
      <table-pagination
        :pagination="pagination"
        :total-attendees="totalSubscribersCount"
        @change="handlePagination($event)"
        @changePerPage="handlePagination($sevent)"
      />
    </div>
  </div>
</template>

<script>
import tableList from '../../accreditations/attendee-table/list.vue'
import tablePagination from '../../accreditations/attendee-table/pagination.vue'
import { GET_ALL_MEMBERSHIP_USERS } from '@/graphql/membershipUser.graphql'
import moment from 'moment'

export default {
  name: 'subscription-plan-list',
  components: {
    tableList,
    tablePagination,
  },
  props: {
    organizationSlug: {
      type: String,
    },
  },
  data() {
    const { pagination } = this.getInitialFromQueryParams()

    return {
      members: [],
      pagination,
      showDeleteDialog: false,
      openCreateModal: false,
      openUpdateModal: false,
      selected: [],
      attendeeFields: {},
      visibleFields: ['Name', 'Member ID No.', 'Membership', 'Bought', 'Expires'],
      totalSubscribersCount: 0,
    }
  },
  methods: {
    async handlePagination({ page, per_page }) {
      const { page: currentPage, per_page: currentPerPage } = this.pagination
      if (currentPage > page && currentPage === 1) return
      if (page > currentPage && !(this.totalSubscribersCount - currentPerPage * currentPage > 0))
        return

      this.pagination = {
        ...this.pagination,
        per_page: per_page === 'All' ? -1 : per_page,
        page: page,
      }

      await this.addPaginationToRoute(this.pagination)
    },
    async handleSort(sortBy) {
      const { per_page, page, sortBy: thisSortBy, descending } = this.pagination
      const pagination = {
        page,
        per_page,
        sortBy,
        descending: sortBy === thisSortBy ? !descending : false,
      }
      await this.addPaginationToRoute(pagination)
      this.pagination = pagination
    },
    getInitialFromQueryParams() {
      const { per_page, page, sortBy, descending } = this.$route.query

      return {
        pagination: {
          page: parseInt(page, 10) || 1,
          per_page: parseInt(per_page, 10) || 10,
          sortBy: sortBy,
          descending: descending ? !!descending : false,
        },
      }
    },
    async addPaginationToRoute({ page, per_page, sortBy, descending }) {
      await this.$router.replace({
        query: {
          ...this.$route.query,
          per_page,
          page,
          sortBy,
          descending: descending ? 1 : 0,
        },
      })
    },
  },
  apollo: {
    getAllMembershipUsers: {
      query: GET_ALL_MEMBERSHIP_USERS,
      variables() {
        return {
          organizationSlug: this.organizationSlug,
        }
      },
      manual: true,
      async result({ loading, data }) {
        if (!loading) {
          const { getAllMembershipUsers } = data
          this.members = getAllMembershipUsers.map(member => {
            return {
              id: member.id,
              name: member.name,
              code: member.code,
              membership: member.membershipPlan.name,
              bought: moment(member.createdAt).format('DD.MM.YYYY HH:mm'),
              expires: moment(member.membershipPlan.to).format('DD.MM.YYYY HH:mm'),
            }
          })
        }
      },
    },
  },
}
</script>

<style scoped>
.container {
  padding: 0 !important;
  margin: 0 !important;
  display: flex;
  flex-direction: column;
  max-width: 64.875rem;
}
.container-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 1.5rem;
}
</style>
